<template>
  <div>
    <Head title="Wohnung" />
    <section class="overflow-hidden text-gray-700 py-3">
      <silent-box :gallery="livingroom">
        <h2>Wohnzimmer</h2>
        <template v-slot:silentbox-item="{ silentboxItem }">
          <div class="w-full p-1 md:p-2">
            <fade-image :src="silentboxItem.src" width="600" height="800" class="block object-cover object-center w-full h-full rounded-lg shadow-md shadow-gray-500" />
          </div>
        </template>
      </silent-box>
    </section>
    <section class="overflow-hidden text-gray-700 py-3">
      <silent-box :gallery="kitchen">
        <h2>Küche (11m²)</h2>
        <template v-slot:silentbox-item="{ silentboxItem }">
          <div class="w-full p-1 md:p-2">
            <fade-image :src="silentboxItem.src" width="600" height="800" class="block object-cover object-center w-full h-full rounded-lg shadow-md shadow-gray-500" />
          </div>
        </template>
      </silent-box>
    </section>
    <section class="overflow-hidden text-gray-700 py-3">
      <silent-box :gallery="bathrooms">
        <h2>Bäder</h2>
        <template v-slot:silentbox-item="{ silentboxItem }">
          <div class="w-full p-1 md:p-2">
            <fade-image :src="silentboxItem.src" width="600" height="800" class="block object-cover object-center w-full h-full rounded-lg shadow-md shadow-gray-500" />
          </div>
        </template>
      </silent-box>
    </section>
    <section class="overflow-hidden text-gray-700 py-3">
      <silent-box :gallery="misc">
        <h2>weitere Bilder</h2>
        <template v-slot:silentbox-item="{ silentboxItem }">
          <div class="w-full p-1 md:p-2">
            <fade-image :src="silentboxItem.src" width="600" height="800" class="block object-cover object-center w-full h-full rounded-lg shadow-md shadow-gray-500" />
          </div>
        </template>
      </silent-box>
    </section>
  </div>
</template>

<script>
import { Head } from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout'
import FadeImage from '@/Shared/FadeImage'

import 'vue-silentbox/dist/style.css'

export default {
  components: {
    Head,
    FadeImage,
  },
  layout: Layout,

  data() {
    return {
      livingroom: [
        {
          description: 'Wohnzimmer',
          src: 'https://cdn.ferienwohnung-vogelschar.de/rs,s:600/fewo_vogelschar__wohnzimmer_01.jpg',
          thumbnailWidth: '600',
        },
        {
          description: 'Wohnzimmer',
          src: 'https://cdn.ferienwohnung-vogelschar.de/rs,s:600/fewo_vogelschar__wohnzimmer_03.jpg',
          thumbnailWidth: '600',
        },
        {
          description: 'Wohnzimmer',
          src: 'https://cdn.ferienwohnung-vogelschar.de/rs,s:600/fewo_vogelschar__wohnzimmer_04.jpg',
          thumbnailWidth: '600',
        },
      ],
      kitchen: [
        {
          description: 'Küche',
          src: 'https://cdn.ferienwohnung-vogelschar.de/rs,s:600/fewo_vogelschar__kueche_01.jpg',
          thumbnailWidth: '600',
        },
        {
          description: 'Küche',
          src: 'https://cdn.ferienwohnung-vogelschar.de/rs,s:600/fewo_vogelschar__kueche_02.jpg',
          thumbnailWidth: '600',
        },
        {
          description: 'Küche',
          src: 'https://cdn.ferienwohnung-vogelschar.de/rs,s:600/fewo_vogelschar__kueche_03.jpg',
          thumbnailWidth: '600',
        },
      ],
      bathrooms: [
        {
          description: 'Duschbad Erdgeschoss',
          src: 'https://cdn.ferienwohnung-vogelschar.de/rs,s:600/fewo_vogelschar__bad_unten_01.jpg',
          thumbnailWidth: '600',
        },
        {
          description: 'Duschbad Erdgeschoss',
          src: 'https://cdn.ferienwohnung-vogelschar.de/rs,s:600/fewo_vogelschar__bad_unten_02.jpg',
          thumbnailWidth: '600',
        },
        {
          description: 'Wannenbad Obergeschoss',
          src: 'https://cdn.ferienwohnung-vogelschar.de/rs,s:600/fewo_vogelschar__bad_wanne_01.jpg',
          thumbnailWidth: '600',
        },
        {
          description: 'Wannenbad Obergeschoss',
          src: 'https://cdn.ferienwohnung-vogelschar.de/rs,s:600/fewo_vogelschar__bad_wanne_02.jpg',
          thumbnailWidth: '600',
        },
        {
          description: 'Duschbad Obergeschoss',
          src: 'https://cdn.ferienwohnung-vogelschar.de/rs,s:600/fewo_vogelschar__bad_dusche_02.jpg',
          thumbnailWidth: '600',
        },
        {
          description: 'Duschbad Obergeschoss',
          src: 'https://cdn.ferienwohnung-vogelschar.de/rs,s:600/fewo_vogelschar__bad_dusche_04.jpg',
          thumbnailWidth: '600',
        },
      ],
      misc: [
        {
          description: 'Hauseingang',
          src: 'https://cdn.ferienwohnung-vogelschar.de/rs,s:600/fewo_vogelschar__eingang_01.jpg',
          thumbnailWidth: '600',
        },
        {
          description: 'Hausflur Erdgeschoss',
          src: 'https://cdn.ferienwohnung-vogelschar.de/rs,s:600/fewo_vogelschar__flur_unten_01.jpg',
          thumbnailWidth: '600',
        },
        {
          description: 'Hausflur Obergeschoss',
          src: 'https://cdn.ferienwohnung-vogelschar.de/rs,s:600/fewo_vogelschar__flur_oben_01.jpg',
          thumbnailWidth: '600',
        },
      ],
      lightboxList: [],
      lightboxIndex: 0,
    }
  },
  methods: {
    openLightbox: function (list, index) {
      this.lightboxList = list
      this.lightboxIndex = index
    },
  },
}
</script>
